document.addEventListener("DOMContentLoaded", function () {
  initLogoToggle();
  initMegamenu();
  initMegamenuNavigation();
});

function initLogoToggle() {
  const svgWrapper = document.querySelector(".svg-wrapper.svg-dynamic-logo");
  const sectionHeader = document.querySelector(".section-dynamic-header");

  if (svgWrapper && sectionHeader) {
    updateScrollAttributes(svgWrapper, sectionHeader);

    window.addEventListener("scroll", function () {
      updateScrollAttributes(svgWrapper, sectionHeader);
    });
  }
}

function updateScrollAttributes(svgWrapper, section) {
  const sectionHeader = document.querySelector(".section-dynamic-header");
  
  // Use a smaller threshold for mobile devices to make the header sticky sooner
  const scrollThreshold = window.innerWidth <= 749 ? 10 : (sectionHeader.offsetHeight + 3);

  if (window.scrollY > scrollThreshold) {
    svgWrapper.setAttribute("data-state", "scrolled");
    section.setAttribute("data-state", "scrolled");
  } else {
    svgWrapper.setAttribute("data-state", "default");
    section.setAttribute("data-state", "default");
  }
}

function initMegamenu() {
  initToggleButtons();
  initHoverActions();
  initClickActions();
}

function initToggleButtons() {
  const openButton = document.getElementById("dynamic-header__megamenu-open");
  const closeButton = document.getElementById("dynamic-header__megamenu-close");
  const sectionHeader = document.querySelector(".section-dynamic-header");
  const sectionMegamenu = document.querySelector(".dynamic-megamenu");
  const background = document.querySelector(".dynamic-megamenu__background");
  const body = document.querySelector("body");

  if (openButton && closeButton && sectionHeader && sectionMegamenu) {
    openButton.addEventListener("click", () => {
      // Force a reflow before changing states to ensure proper rendering
      void sectionMegamenu.offsetWidth;
      
      sectionHeader.setAttribute("data-toggle", "open");
      sectionMegamenu.setAttribute("data-toggle", "open");
      body.classList.add("scroll-disabled");
      
      // Force hardware acceleration
      background.style.transform = 'translateZ(0)';
      background.style.webkitTransform = 'translateZ(0)';
    });

    closeButton.querySelector("svg").addEventListener("click", () => {
      sectionHeader.setAttribute("data-toggle", "close");
      sectionMegamenu.setAttribute("data-toggle", "close");
      body.classList.remove("scroll-disabled");
    });

    background.addEventListener("click", () => {
      sectionHeader.setAttribute("data-toggle", "close");
      sectionMegamenu.setAttribute("data-toggle", "close");
      body.classList.remove("scroll-disabled");
    });
  }
}

function initHoverActions() {
  const menuLinks = document.querySelectorAll(".megamenu-naviaton__link");
  const subNavigationItems = document.querySelectorAll(".sub-navigation__item");
  const navigation = document.querySelector(".dynamic-megamenu__navigation");
  const closeButton = document.getElementById("dynamic-header__megamenu-close");

  navigation.addEventListener("mouseover", () => {
    subNavigationItems.forEach(item => item.setAttribute("data-toggle", "close"));
  });

  closeButton.addEventListener("mouseover", () => {
    subNavigationItems.forEach(item => item.setAttribute("data-toggle", "close"));
  });

  if (menuLinks.length > 0 && subNavigationItems.length > 0) {
    menuLinks.forEach(link => {
      link.addEventListener("mouseover", (event) => {
        if (window.innerWidth > 750) {
          event.stopPropagation();
          console.log("hover")

          const dataId = link.getAttribute("data-id");

          subNavigationItems.forEach(item => item.setAttribute("data-toggle", "close"));

          const targetItem = document.querySelector(`.sub-navigation__item[data-id="${dataId}"]`);
          if (targetItem) {
            targetItem.setAttribute("data-toggle", "open");
          }
        }
      });
    });
  }
}

function initClickActions() {
  const menuLinks = document.querySelectorAll(".megamenu-naviaton__link");

  menuLinks.forEach(link => {
    link.addEventListener("click", (event) => {
      if (window.innerWidth < 749) {
        // Check if the click is on a dropdown element or a direct link
        const clickedElement = event.target;
        const isDropdownElement = clickedElement.classList.contains('megamenu-naviaton__link-text--mobile-dropdown') || 
                                 clickedElement.classList.contains('navigation-link__chevron--mobile');
        
        // Only prevent default if it's a dropdown element, not a direct link
        if (isDropdownElement || !event.target.closest('a')) {
          event.preventDefault();
          
          const dataId = link.getAttribute("data-id");

          const targetItem = document.querySelector(`.megamenu-navigation__mobile-submenu[data-id="${dataId}"]`);
          const isOpen = targetItem?.getAttribute("data-toggle") === "open";

          const allSubMenus = document.querySelectorAll(".megamenu-navigation__mobile-submenu");
          allSubMenus.forEach(item => item.setAttribute("data-toggle", "close"));
          menuLinks.forEach(link => { link.setAttribute("data-toggle", "close") })

          if (targetItem && !isOpen) {
            targetItem.setAttribute("data-toggle", "open");
            link.setAttribute("data-toggle", "open");
          }
        }
        // If it's a direct link, let the default action happen (navigation)
      }
    });
  });
}

function initMegamenuNavigation() {
  const hoverableLinks = document.querySelectorAll(".megamenu-naviaton__link");

  hoverableLinks.forEach(link => {
    link.addEventListener("mouseenter", () => {
      if (window.innerWidth > 750) {
        link.setAttribute("data-toggle", "open");
      }
    });

    link.addEventListener("mouseleave", () => {
      if (window.innerWidth > 750) {
        link.setAttribute("data-toggle", "close");
      }
    });
  });
}
